import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';

const Field = styled.div`
  width: 65%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${({ profileView }) => `${profileView ? '10px' : '12px'}`};
`;

const FormSelect = styled(Form.Select)`
  width: 50%;
  display: flex;
  gap: 35px;
  justify-content: left;
  align-items: center;
  .ui.dropdown {
    min-width: 25% !important;
    max-width: 40%;
  }
`;

const InputStyled = styled(Form.Input)`
  margin-left: 5px;
`;

const KEYS = {
  completion_criteria: 'complete_criteria',
  reattempt_criteria: 'reattempt_criteria',
};

const CRITERIA = ['=', '<', '>', '<=', '>='];

const OPERATOR = {
  GREATEREQUAL: '>=',
};

export default class CriteriaForm extends PureComponent {
  static propTypes = {
    selectedValue: PropTypes.shape({}).isRequired,
    handleChangeDropdown: PropTypes.func.isRequired,
    onTextChange: PropTypes.func.isRequired,
  };

  render() {
    const {
      selectedValue,
      value,
      disabled,
      dropdownData,
      handleChangeDropdown,
      onTextChange,
    } = this.props;
    const { criteria: completionOp = OPERATOR.GREATEREQUAL } = dropdownData || {};
    const { name } = selectedValue || {};
    const operators = CRITERIA.map(op => ({ key: op, text: op, value: op }));
    return (
      <Field>
        <FormSelect
          name={KEYS[name]}
          label={'Criteria'}
          options={operators}
          disabled={disabled}
          onChange={handleChangeDropdown}
          value={completionOp}
          width={4}
        />

        <InputStyled
          name={KEYS[name]}
          label={''}
          disabled={disabled}
          value={value || selectedValue.default}
          type="number"
          onChange={onTextChange}
        />
      </Field>
    );
  }
}
